(ns nl.mediquest.be-my-coach-frontend.views.map
  (:require
   [nl.mediquest.be-my-coach-frontend.events :as events]
   [nl.mediquest.be-my-coach-frontend.subs :as subs]
   [nl.mediquest.be-my-coach-frontend.views.map.leaflet-interop
    :as leaflet-interop]
   [nl.mediquest.be-my-coach-frontend.views.zorgverleners
    :refer [zorgverlener-popup]]
   [re-frame.core :as re-frame]))

(defn- zorgverlener-marker
  [{:keys [id] :as zorgverlener}]
  (let [highlighted? (= id @(re-frame/subscribe
                             [::subs/highlighted-zorgverlener-id]))
        marker-handler (leaflet-interop/hover-and-click-marker-handler-maker
                        #(re-frame/dispatch
                          [::events/highlight-zorgverlener (when-not highlighted? id)]))]
    ^{:key id}
    [leaflet-interop/marker
     {:position (leaflet-interop/zorgverlener->latlng zorgverlener)
      :event-handlers marker-handler}
     [:f> leaflet-interop/reactive-popup
      (leaflet-interop/popup-auto-open-props-maker
       highlighted?
       #(when highlighted? (re-frame/dispatch [::events/highlight-zorgverlener nil])))
      [:div
       {:on-click #(re-frame/dispatch [::events/highlight-zorgverlener id])}
       [zorgverlener-popup zorgverlener]]]]))

(defn- zorgverlener-markers [zorgverleners]
  [:<>
   (doall (map zorgverlener-marker @zorgverleners))])

(defn view []
  [leaflet-interop/base-map
   (let [zorgverleners (re-frame/subscribe [::subs/zorgverleners])]
     (when (seq @zorgverleners)
       [:<>
        [:f> leaflet-interop/keep-markers-in-view zorgverleners]
        [zorgverlener-markers zorgverleners]]))])
